import SoftwareApiClient from '~/apiClients/SoftwareApiClient';
import SoftwareType from "~/models/softwareStrategy/Software";
import { TaggingPlanAttributes } from "~/models/TaggingPlan";
import SoftwareTrackerApiClient from '../apiClients/SoftwareTrackerApiClient';

export interface SoftwareAttributes {
  id: number,
  softwareKey: string,
  name: string,
  type: number,
  isDeleted: boolean,
  createdAt: string,
  updatedAt?: string,
  taggingPlans?: Array<TaggingPlanAttributes>
}

export interface SoftwareCreationAttributes {
  name: string;
  type: number;
}

export interface SoftwareUpdateAttributes {
  name: string;
}

export const SoftwareTypes = [
  { value: SoftwareType.AUTO, label: 'Auto' },
  { value: SoftwareType.KEYLOOP, label: 'Keyloop' },
  { value: SoftwareType.THIRD_PARTY, label: 'Third party' },
] as Array<{ value: SoftwareType, label: string }>;

export class Software {
  constructor(private readonly attributes: SoftwareAttributes) {
  }
  get id(): number {
    return this.attributes.id;
  }
  get softwareKey(): string {
    return this.attributes.softwareKey ?? '';
  }
  get name(): string {
    return this.attributes.name ?? '';
  }
  get type(): number {
    return this.attributes.type;
  }
  get isDeleted(): boolean {
    return this.attributes.isDeleted;
  }
  get safeAttributes(): object {
    return {
      type: this.type,
      id: this.attributes.id,
    };
  }
  get taggingPlans(): TaggingPlanAttributes[] {
    return this.attributes.taggingPlans;
  }

  static async findAll(withTaggingPlans: boolean = false) {
    return await this.getApiClient().provideSoftware(withTaggingPlans);
  }

  static async create(attributes: SoftwareCreationAttributes) {
    return await this.getApiClient().createSoftware(attributes);
  }

  async update(attributes: SoftwareUpdateAttributes): Promise<Software> {
    return await Software.getApiClient().updateSoftware(attributes);
  }

  async hasTrackers() {
    return (await new SoftwareTrackerApiClient().provideSoftwareTrackers(this.id)).length > 0;
  }

  static async delete(id: number) {
    return await this.getApiClient().deleteSoftware(id);
  }

  private static getApiClient(): SoftwareApiClient {
    return new SoftwareApiClient();
  }
}
